/* Baaby virtual try-on — product-page embed.
   Expects window.__baabyTryonConfig { sectionId, apiOrigin } before load. */
(function () {
  "use strict";
  if (window.__baabyTryonInit) return;
  window.__baabyTryonInit = true;

  var cfg = window.__baabyTryonConfig || {};
  var API_ORIGIN = cfg.apiOrigin || "https://baaby-lite.stylor.app";
  var SECTION_ID = cfg.sectionId || "";
  var DRESS_NOTES = typeof cfg.dressNotes === "string" ? cfg.dressNotes : "";
  var MAX_DIM = 1280;
  var MAX_DRESS_IMAGES = 4;
  var PHOTO_KEY = "baaby_tryon_photo";
  var CACHE_KEY = "baaby_tryon_cache";
  var MAX_CACHE = 24;

  var state = { dress: null, photoB64: null, photoUrl: null, photoHash: null };

  var css =
    ".bby-overlay{position:fixed;inset:0;z-index:99999;background:rgba(20,18,16,.55);display:flex;align-items:center;justify-content:center;padding:16px;overscroll-behavior:contain}" +
    ".bby-modal{background:#faf8f5;color:#161412;width:min(560px,100%);max-height:min(92vh,92dvh);overflow:auto;-webkit-overflow-scrolling:touch;border-radius:2px;padding:28px;font-family:Georgia,'Times New Roman',serif;position:relative}" +
    ".bby-modal *{box-sizing:border-box}" +
    ".bby-x{position:absolute;top:10px;right:10px;background:none;border:0;font-size:28px;cursor:pointer;color:#161412;line-height:1;width:44px;height:44px;display:flex;align-items:center;justify-content:center;z-index:2;touch-action:manipulation}" +
    ".bby-kicker{font:500 10px/1 sans-serif;letter-spacing:.22em;text-transform:uppercase;color:#8a8378;margin:0 0 6px;padding-right:36px}" +
    ".bby-h{font-size:24px;font-weight:400;margin:0 0 18px;font-style:italic;padding-right:36px;line-height:1.25}" +
    ".bby-row{display:flex;gap:14px;align-items:flex-start;margin-bottom:16px}" +
    ".bby-row img{width:96px;aspect-ratio:3/4;object-fit:cover;flex-shrink:0}" +
    ".bby-drop{display:block;position:relative;border:2px dashed #b5ad9f;padding:24px 16px;min-height:112px;text-align:center;cursor:pointer;font:400 13px/1.5 sans-serif;color:#6f6a62;margin:12px 0;touch-action:manipulation;-webkit-tap-highlight-color:rgba(22,20,18,.08)}" +
    ".bby-drop-inner{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px;min-height:72px;pointer-events:none}" +
    ".bby-drop-icon{font-size:28px;line-height:1;color:#8a8378}" +
    ".bby-drop-text{font-size:15px;line-height:1.4}" +
    ".bby-upload-btn{display:inline-block;background:#111;color:#fff;border:0;padding:14px 28px;font:500 12px/1 sans-serif;letter-spacing:.14em;text-transform:uppercase;min-height:48px;min-width:180px;touch-action:manipulation}" +
    ".bby-drop img{max-width:100%;max-height:min(30vh,30dvh);display:block;margin:0 auto;pointer-events:none}" +
    ".bby-consent{display:flex;gap:12px;font:400 12px/1.5 sans-serif;color:#4a463f;margin:14px 0;align-items:flex-start;touch-action:manipulation}" +
    ".bby-consent input{margin-top:2px;width:20px;height:20px;min-width:20px;flex-shrink:0;cursor:pointer}" +
    ".bby-consent a{color:#4a463f;text-decoration:underline}" +
    ".bby-cta{display:inline-block;width:100%;background:#111;color:#fff;border:0;padding:15px;font:500 12px/1 sans-serif;letter-spacing:.18em;text-transform:uppercase;cursor:pointer;text-align:center;text-decoration:none;min-height:48px;touch-action:manipulation}" +
    ".bby-cta[disabled]{opacity:.4;cursor:default}" +
    ".bby-cta.ghost{background:none;color:#111;border:1px solid #111;margin-top:10px}" +
    ".bby-note{font:400 11px/1.6 sans-serif;color:#8a8378;margin-top:12px}" +
    ".bby-spin{margin:40px auto;width:34px;height:34px;border:2px solid #d8d2c6;border-top-color:#161412;border-radius:50%;animation:bbyspin .9s linear infinite}" +
    "@keyframes bbyspin{to{transform:rotate(360deg)}}" +
    ".bby-out{width:100%;max-height:min(44vh,44dvh);object-fit:contain;display:block;background:#151310;cursor:zoom-in}" +
    ".bby-row2{display:flex;gap:10px;margin-top:14px}" +
    ".bby-row2 .bby-cta{margin:0}" +
    ".bby-err{font:400 13px/1.5 sans-serif;color:#8c2f2f;margin:12px 0}" +
    ".bby-tips{font:400 12px/1.55 sans-serif;color:#6f6a62;margin:0 0 12px;padding:12px 14px;background:#f0ebe3;border-left:2px solid #b5ad9f}" +
    ".bby-tips strong{display:block;font:500 10px/1 sans-serif;letter-spacing:.14em;text-transform:uppercase;color:#8a8378;margin-bottom:6px}" +
    ".bby-prev{display:grid;grid-template-columns:repeat(auto-fill,minmax(72px,1fr));gap:10px;margin:12px 0 16px}" +
    ".bby-prev button{border:1px solid #d8d2c6;padding:0;background:none;cursor:pointer;min-height:44px;touch-action:manipulation}" +
    ".bby-prev button:hover,.bby-prev button.active{border-color:#161412}" +
    ".bby-prev img{width:100%;aspect-ratio:3/4;object-fit:cover;display:block}" +
    ".bby-prev-label{font:500 9px/1 sans-serif;letter-spacing:.14em;text-transform:uppercase;color:#8a8378;margin:0 0 8px}" +
    ".bby-back{min-height:44px;touch-action:manipulation}" +
    "@media (max-width:640px){" +
    ".bby-overlay{padding:0;align-items:stretch}" +
    ".bby-modal{width:100%;max-height:100%;height:100%;max-height:100dvh;border-radius:0;padding:16px;padding-top:max(16px,env(safe-area-inset-top));padding-bottom:max(16px,env(safe-area-inset-bottom));padding-left:max(16px,env(safe-area-inset-left));padding-right:max(16px,env(safe-area-inset-right))}" +
    ".bby-h{font-size:20px;margin-bottom:14px}" +
    ".bby-drop{min-height:140px;padding:28px 16px;margin:10px 0}" +
    ".bby-drop-inner{min-height:88px}" +
    ".bby-row2{flex-direction:column}" +
    ".bby-row2 .bby-cta{width:100%}" +
    ".bby-out{max-height:min(52dvh,52vh)}" +
    ".bby-drop img{max-height:min(24dvh,24vh)}" +
    "}";

  var styleEl = document.createElement("style");
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) {
      if (k === "onclick" || k === "onchange") n[k] = attrs[k];
      else n.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) {
      n.appendChild(typeof c === "string" ? document.createTextNode(c) : c);
    });
    return n;
  }

  function imgUrl(src, width) {
    if (!src) return "";
    var base = src.split("?")[0];
    return base + (base.indexOf("?") >= 0 ? "&" : "?") + "width=" + width;
  }

  function formatPrice(cents) {
    return "$" + (Number(cents || 0) / 100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + " AUD";
  }

  function colorOf(product) {
    var opt = (product.options || []).filter(function (o) { return /colou?r/i.test(o.name); })[0];
    return opt && opt.values && opt.values[0] ? opt.values[0] : "";
  }

  function hashStr(s) {
    var h = 0;
    for (var i = 0; i < s.length; i++) h = ((h << 5) - h + s.charCodeAt(i)) | 0;
    return Math.abs(h).toString(36);
  }

  function readStorage(key, fallback) {
    try {
      var raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : fallback;
    } catch (e) {
      return fallback;
    }
  }

  function writeStorage(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) { /* quota */ }
  }

  function savePhoto(b64, dataUrl) {
    writeStorage(PHOTO_KEY, { b64: b64, dataUrl: dataUrl, ts: Date.now() });
    state.photoB64 = b64;
    state.photoUrl = dataUrl;
    state.photoHash = hashStr(b64);
  }

  function loadSavedPhoto() {
    var saved = readStorage(PHOTO_KEY, null);
    if (saved && saved.b64 && saved.dataUrl) {
      state.photoB64 = saved.b64;
      state.photoUrl = saved.dataUrl;
      state.photoHash = hashStr(saved.b64);
      return true;
    }
    return false;
  }

  function cacheKey(handle, photoHash) {
    return handle + ":" + photoHash;
  }

  function getCache() {
    return readStorage(CACHE_KEY, {});
  }

  function getCachedResult(handle, photoHash) {
    var cache = getCache();
    var entry = cache[cacheKey(handle, photoHash)];
    return entry && entry.dataUrl ? entry : null;
  }

  function saveCachedResult(handle, photoHash, dataUrl, title) {
    var cache = getCache();
    cache[cacheKey(handle, photoHash)] = {
      dataUrl: dataUrl,
      ts: Date.now(),
      dressTitle: title,
      dressHandle: handle,
    };
    var keys = Object.keys(cache).sort(function (a, b) {
      return (cache[b].ts || 0) - (cache[a].ts || 0);
    });
    while (keys.length > MAX_CACHE) {
      delete cache[keys.pop()];
    }
    writeStorage(CACHE_KEY, cache);
  }

  function previousForProduct(handle) {
    var cache = getCache();
    return Object.keys(cache)
      .filter(function (k) { return k.indexOf(handle + ":") === 0; })
      .map(function (k) { return cache[k]; })
      .sort(function (a, b) { return (b.ts || 0) - (a.ts || 0); });
  }

  function getProduct() {
    var node = document.getElementById("ProductJson-" + SECTION_ID);
    if (!node || !node.textContent) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function dressImage(product) {
    var variantId = null;
    var select = document.querySelector('[name="id"]');
    if (select) variantId = Number(select.value);
    var variant = (product.variants || []).filter(function (v) { return v.id === variantId; })[0];
    if (variant && variant.featured_image) {
      return typeof variant.featured_image === "string" ? variant.featured_image : variant.featured_image.src;
    }
    if (product.featured_image) {
      return typeof product.featured_image === "string" ? product.featured_image : product.featured_image.src;
    }
    if (product.images && product.images.length) {
      var img = product.images[0];
      return typeof img === "string" ? img : img.src;
    }
    return null;
  }

  function isShopifyCdnUrl(url) {
    return !!url && url.indexOf("cdn.shopify.com") >= 0;
  }

  function imageSrc(img) {
    if (!img) return null;
    return typeof img === "string" ? img : img.src || null;
  }

  function normaliseCdnUrl(src) {
    if (!src) return null;
    var base = src.split("?")[0];
    if (base.indexOf("//") === 0) base = "https:" + base;
    if (!isShopifyCdnUrl(base)) return null;
    return imgUrl(base, 1024);
  }

  function buildDressImageUrls(images, variantId) {
    var urls = [];
    var seen = {};
    function add(src) {
      if (urls.length >= MAX_DRESS_IMAGES) return;
      var u = normaliseCdnUrl(src);
      if (u && !seen[u]) {
        seen[u] = true;
        urls.push(u);
      }
    }
    if (variantId) {
      (images || []).forEach(function (img) {
        var obj = typeof img === "object" && img ? img : null;
        if (obj && obj.variant_ids && obj.variant_ids.indexOf(variantId) >= 0) add(imageSrc(img));
      });
    }
    (images || []).forEach(function (img) { add(imageSrc(img)); });
    return urls;
  }

  function resolveCdnDressUrls(product, cb, errCb) {
    var variantId = null;
    var select = document.querySelector('[name="id"]');
    if (select) variantId = Number(select.value);

    var urls = buildDressImageUrls(product.images || [], variantId);
    if (urls.length) {
      cb(urls);
      return;
    }

    fetch("/products/" + product.handle + ".json")
      .then(function (r) { return r.json(); })
      .then(function (data) {
        urls = buildDressImageUrls(data.product.images || [], variantId);
        if (!urls.length) {
          errCb("Could not resolve valid dress images for try-on.");
          return;
        }
        cb(urls);
      })
      .catch(function () {
        errCb("Could not load dress images. Please refresh and try again.");
      });
  }

  function readPhoto(file, cb, errCb) {
    var url = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function () {
      var scale = Math.min(1, MAX_DIM / Math.max(img.width, img.height));
      var c = document.createElement("canvas");
      c.width = Math.round(img.width * scale);
      c.height = Math.round(img.height * scale);
      c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
      URL.revokeObjectURL(url);
      var dataUrl = c.toDataURL("image/jpeg", 0.88);
      cb(dataUrl.split(",")[1], dataUrl);
    };
    img.onerror = function () { URL.revokeObjectURL(url); errCb(); };
    img.src = url;
  }

  function watermark(b64, cb) {
    var img = new Image();
    img.onload = function () {
      var c = document.createElement("canvas");
      c.width = img.width;
      c.height = img.height;
      var ctx = c.getContext("2d");
      ctx.drawImage(img, 0, 0);
      var fs = Math.max(14, Math.round(img.width / 42));
      ctx.font = "500 " + fs + "px sans-serif";
      ctx.textAlign = "right";
      ctx.fillStyle = "rgba(255,255,255,.75)";
      ctx.shadowColor = "rgba(0,0,0,.35)";
      ctx.shadowBlur = 4;
      ctx.fillText("BAABY · AI PREVIEW", img.width - fs, img.height - fs);
      cb(c.toDataURL("image/jpeg", 0.92));
    };
    img.src = "data:image/jpeg;base64," + b64;
  }

  var overlay, modal, scrollLock;

  function open() {
    var product = getProduct();
    if (!product || !dressImage(product)) {
      alert("Try-on is not available for this product yet.");
      return;
    }
    state.dress = product;
    loadSavedPhoto();

    scrollLock = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    overlay = el("div", { class: "bby-overlay", onclick: function (e) { if (e.target === overlay) close(); } });
    modal = el("div", { class: "bby-modal", role: "dialog", "aria-modal": "true" });
    overlay.appendChild(modal);
    document.body.appendChild(overlay);
    renderUpload();
  }

  function close() {
    if (overlay) { overlay.remove(); overlay = null; }
    document.body.style.overflow = scrollLock || "";
  }

  function header(title) {
    return [
      el("button", { class: "bby-x", "aria-label": "Close", onclick: close }, ["×"]),
      el("p", { class: "bby-kicker" }, ["Baaby — Virtual Try-On"]),
      el("h2", { class: "bby-h" }, [title]),
    ];
  }

  function render(children) {
    modal.replaceChildren();
    children.forEach(function (c) { modal.appendChild(c); });
    modal.scrollTop = 0;
  }

  function renderLoading(msg) {
    render(header("One moment").concat([
      el("div", { class: "bby-spin" }),
      el("p", { class: "bby-note", style: "text-align:center" }, [msg]),
    ]));
  }

  function renderError(msg, retryFn) {
    render(header("Something went wrong").concat([
      el("p", { class: "bby-err" }, [msg]),
      el("button", { class: "bby-cta ghost", onclick: retryFn || renderUpload }, ["Try again"]),
    ]));
  }

  function renderResult(dataUrl, fromCache) {
    var d = state.dress;
    var bin = atob(dataUrl.split(",")[1]);
    var bytes = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    var blobUrl = URL.createObjectURL(new Blob([bytes], { type: "image/jpeg" }));

    var parts = header("Your Baaby look").concat([
      el("a", { href: blobUrl, target: "_blank", rel: "noopener", title: "Open full size" }, [
        el("img", { class: "bby-out", src: dataUrl, alt: "AI preview of " + d.title }),
      ]),
      el("div", { class: "bby-row2" }, [
        el("a", { class: "bby-cta", style: "flex:1", href: dataUrl, download: "baaby-preview.jpg" }, ["Save image"]),
        el("a", { class: "bby-cta ghost", style: "flex:1", href: blobUrl, target: "_blank", rel: "noopener" }, ["Full size ↗"]),
      ]),
      el("button", { class: "bby-cta ghost bby-back", onclick: renderUpload }, ["← Try another photo"]),
      el("button", { class: "bby-back", style: "margin:12px 0 0;background:none;border:0;font:400 12px/1 sans-serif;color:#6f6a62;cursor:pointer;text-decoration:underline;padding:8px 0", onclick: function () { generate(true); } }, ["Generate a fresh preview"]),
      el("p", { class: "bby-note", style: "margin-top:8px" }, [
        fromCache ? "Loaded from your saved previews — no new generation needed. " : "",
        "AI-generated preview. Fit, colour and drape are indicative only. Every Baaby piece is handmade to order in Melbourne.",
      ]),
    ]);
    render(parts);
  }

  function renderUpload() {
    state.dress = getProduct() || state.dress;
    var d = state.dress;
    if (!d) return renderError("Product data unavailable.", close);

    var imageSrc = dressImage(d);
    var fileInput = el("input", { type: "file", accept: "image/*", id: "bby-file-input", style: "position:absolute;width:1px;height:1px;opacity:0;overflow:hidden;clip:rect(0,0,0,0)" });
    fileInput.onchange = function () {
      if (!fileInput.files[0]) return;
      readPhoto(fileInput.files[0], function (b64, dataUrl) {
        savePhoto(b64, dataUrl);
        renderUpload();
      }, function () { renderError("That file couldn't be read as an image.", renderUpload); });
    };

    var drop = el("label", { class: "bby-drop", for: "bby-file-input" }, [
      state.photoUrl
        ? el("img", { src: state.photoUrl, alt: "Your photo" })
        : el("div", { class: "bby-drop-inner" }, [
            el("span", { class: "bby-drop-icon", "aria-hidden": "true" }, ["+"]),
            el("span", { class: "bby-drop-text" }, ["Tap to upload a photo"]),
            el("span", { class: "bby-upload-btn" }, ["Choose photo"]),
          ]),
    ]);
    if (state.photoUrl) {
      drop.appendChild(el("div", { class: "bby-drop-inner", style: "margin-top:12px" }, [
        el("span", { class: "bby-upload-btn" }, ["Change photo"]),
      ]));
    }

    var consent = el("input", { type: "checkbox", id: "bby-consent" });
    var goBtn = el("button", { class: "bby-cta", disabled: "" }, ["Generate my preview"]);
    function sync() {
      if (state.photoB64 && consent.checked) goBtn.removeAttribute("disabled");
      else goBtn.setAttribute("disabled", "");
    }
    consent.onchange = sync;
    sync();
    goBtn.onclick = function () { generate(false); };

    var parts = header("Try on " + d.title).concat([
      el("div", { class: "bby-row" }, [
        el("img", { src: imgUrl(imageSrc, 200), alt: d.title }),
        el("div", {}, [
          el("div", { style: "font-size:15px" }, [d.title]),
          el("div", { style: "font:400 12px/1.5 sans-serif;color:#6f6a62" },
            [formatPrice(d.variants[0] && d.variants[0].price) + (colorOf(d) ? " · " + colorOf(d) : "")]),
        ]),
      ]),
    ]);

    var prev = previousForProduct(d.handle);
    if (prev.length) {
      parts.push(el("p", { class: "bby-prev-label" }, ["Your saved previews for this dress"]));
      var grid = el("div", { class: "bby-prev" });
      prev.forEach(function (entry) {
        var btn = el("button", { type: "button", onclick: function () {
          renderResult(entry.dataUrl, true);
        } }, [
          el("img", { src: entry.dataUrl, alt: entry.dressTitle || d.title }),
        ]);
        grid.appendChild(btn);
      });
      parts.push(grid);
    }

    parts.push(
      el("div", { class: "bby-tips" }, [
        el("strong", {}, ["Photo tips for best results"]),
        el("span", {}, [
          "Stand facing the camera, in good light, showing yourself from the knees up (full body is ideal). " +
          "Avoid back views, extreme side angles, face-only selfies, or very dark/blurry shots. Group photos are fine.",
        ]),
      ]),
      drop,
      fileInput,
      el("label", { class: "bby-consent", for: "bby-consent" }, [
        consent,
        el("span", {}, [
          "I confirm everyone in this photo consents to processing this AI preview and that this complies with the terms set out in our ",
          el("a", { href: "/policies/privacy-policy", target: "_blank", rel: "noopener" }, ["Privacy Policy"]),
          ". Renders are indicative only and may be inaccurate in depicting some garment details.",
        ]),
      ]),
      goBtn
    );

    render(parts);
  }

  function generate(force) {
    var d = getProduct() || state.dress;
    if (!d || !state.photoB64) return;

    var handle = d.handle;
    var photoHash = state.photoHash || hashStr(state.photoB64);
    var cached = !force && getCachedResult(handle, photoHash);

    if (cached) {
      renderResult(cached.dataUrl, true);
      return;
    }

    renderLoading("Checking your photo, then styling your preview — about 15–25 seconds…");

    resolveCdnDressUrls(d, function (cdnUrls) {
      fetch(API_ORIGIN + "/api/generate", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          photo: state.photoB64,
          dressImageUrls: cdnUrls,
          dressTitle: d.title,
          dressColor: colorOf(d),
          dressHandle: d.handle,
          dressNotes: DRESS_NOTES,
        }),
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (r.ok) return data;
            var err = new Error(typeof data.error === "string" ? data.error : "Generation failed. Please try again.");
            err.code = data.code;
            throw err;
          });
        })
        .then(function (data) {
          watermark(data.image, function (dataUrl) {
            saveCachedResult(handle, photoHash, dataUrl, d.title);
            renderResult(dataUrl, false);
          });
        })
        .catch(function (e) {
          var msg = e && e.message ? e.message : "Generation failed. Please try again.";
          // Unsuitable photos → send them back to upload, not a blind retry
          var retry = e && e.code === "photo_unsuitable" ? renderUpload : function () { generate(force); };
          renderError(msg, retry);
        });
    }, function (msg) {
      renderError(msg, renderUpload);
    });
  }

  document.querySelectorAll("[data-baaby-tryon-trigger]").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      open();
    });
  });
})();
